import { createSvgIcon } from '@mui/material';
import { ReactComponent as Icon } from 'assets/customIcons/pdf.svg';

const PdfIcon = createSvgIcon(<Icon />, 'Pdf');

export default PdfIcon;
